export default "__VITE_ASSET__0aca4e2d__"